const pluginName = 'accessCodesPlugin';
const defaults = {
  accessCodeUrl: null,
  callbacks: {
    accessCodeValidated: () => {},
  },
  i18n: {
    accessCodes: {
      validating: null,
      validated: null,
      validationFailed: null,
    },
  },
  selectors: {
    controls: '.js-access-code-controls',
    input: '.js-access-code-input',
    validate: '.js-submit-access-code-btn',
    feedback: '.js-access-code-feedback',
    alert: '.js-access-code-alert',
    panel: '[data-js-access-code-panel]',
    toggle: '[data-js-access-code-toggle]',
  },
};
let windowWidth;

/**
 * Calls the provided custom callback and triggers the provided custom plugin event (if they exist)
 * @param data
 * @param hookName
 * @param parameters
 */
const triggerHook = (data, hookName, ...parameters) => {
  data.elements.$element
    .trigger(`${pluginName}.${hookName}`, [data.elements.$element, data, ...parameters]);
  data.settings.callbacks[hookName]
    .call(data.elements.$element, data.elements.$element, data, ...parameters);
};

/**
 * Enable or disable the access code controls. If enabling, focus the input
 * @param data
 * @param enabled
 */
const toggleAccessCodeControls = (data, enabled) => {
  data.elements.$element.find(data.settings.selectors.controls).prop('disabled', !enabled);

  if (enabled) {
    data.elements.$element.find(data.settings.selectors.input).focus();
  }
};

/**
 * Apply feedback classes and fill in the feedback paragraph with text (but clear all of that first)
 * @param data
 * @param feedback
 * @param stateClasses
 */
const accessCodeFeedback = (data, feedback = '', stateClasses = '') => {
  // it's important to have a nice fresh start
  data.elements.$element.find(data.settings.selectors.feedback).addClass('hidden').empty();
  data.elements.$element.removeClass('has-error has-success');

  if (feedback) {
    data.elements.$element.find(data.settings.selectors.feedback).removeClass('hidden').html(feedback);
  }

  if (stateClasses) {
    data.elements.$element.addClass(stateClasses);
  }
};

/**
 * Add the error class and some error text
 * @param data
 * @param response
 */
const accessCodeError = (data, response) => {
  toggleAccessCodeControls(data, true);
  accessCodeFeedback(
    data,
    response?.responseJSON?.errors?.[0] || data.settings.i18n.accessCodes.validationFailed,
    'has-error',
  );
};

/**
 * Check if the code was valid and add the success state, otherwise trip the error
 * @param data
 * @param valid
 * @param code
 */
const accessCodeResponse = (data, { valid }, code) => {
  if (!valid) {
    accessCodeError(data, data.settings.i18n.accessCodes.validationFailed);
    return;
  }

  accessCodeFeedback(
    data,
    `${data.settings.i18n.accessCodes.validated} <strong>${code}</strong>`,
    'has-success',
  );
  triggerHook(data, 'accessCodeValidated');
};

/**
 * If there's a code, send it to the server and see what it says
 * @param data
 * @param event
 */
const submitAccessCode = (data, event) => {
  const code = data.elements.$element.find(data.settings.selectors.input).val();

  event.preventDefault();

  if (code === '') {
    return;
  }

  data.elements.$element.find(data.settings.selectors.alert).addClass('hidden');
  accessCodeFeedback(data, data.settings.i18n.accessCodes.validating);
  toggleAccessCodeControls(data, false);

  $.ajax({
    url: data.settings.accessCodeUrl,
    type: 'post',
    data: {
      access_code: code,
    },
  })
    .done((response) => accessCodeResponse(data, response, code))
    .fail((response) => accessCodeError(data, response));
};

/**
 * Uppercase all the codes
 * @param data
 * @param event
 */
const uppercaseAccessCode = (data, event) => {
  const $input = $(event.currentTarget);

  $input.val($input.val().toUpperCase());
};

/**
 * Fire up
 * @param $element
 * @param options
 */
const initialize = ($element, options) => {
  if ($element.data(pluginName)) {
    return;
  }

  const settings = $.extend(true, {}, defaults, options);
  const elements = {
    $element,
  };
  const data = {
    settings,
    elements,
  };

  data.elements.$element.data(pluginName, data);
  data.elements.$element.on('submit', (event) => submitAccessCode(data, event));
  data.elements.$element.on('keyup', settings.selectors.input, (event) => uppercaseAccessCode(data, event));

  if (windowWidth <= 976) {
    data.elements.$element.find(settings.selectors.panel).removeClass('in');
  }
};

/**
 * Plugin
 * @param methodOrOptions
 * @returns {jQuery}
 */
const plugin = function plugin(methodOrOptions) {
  if (typeof methodOrOptions === 'object' || !methodOrOptions) {
    return this.each((index, element) => initialize($(element), methodOrOptions));
  }

  return $.error(`Method ${methodOrOptions} does not exist in ${pluginName}`);
};

$(() => {
  if (pluginName in $.fn) {
    return;
  }

  windowWidth = $(window).width();

  $.extend($.fn, {
    [pluginName]: plugin,
  });
});
